import { useQuery } from 'react-query';
import { V2 } from 'types/swagger/clarifai-api';
import { listModelVersions } from '../listModelVersions';

export const useListModelVersions = (req: { params: V2.V2ListModelVersions.RequestParams; query: V2.V2ListModelVersions.RequestQuery }) => {
  return useQuery(
    ['V2ListModelVersions', req],
    () => {
      return listModelVersions(req.params, req.query);
    },
    {
      enabled: !!req.params.modelId,
    },
  );
};
